import { baseApi } from './baseApi';
import type { ApiResponse } from '../../types/api';

interface ProfitsResponse {
  profits: {
    smmworld?: number;
    smmcpan?: number;
    mix4card?: number;
    [key: string]: number | undefined;
  };
  total: number;
}

interface ProviderProfitResponse {
  providerId: string;
  profit: number;
}

export const profitsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfits: builder.query<ApiResponse<ProfitsResponse>, void>({
      query: () => ({
        url: '/profits',
        method: 'GET',
      }),
      providesTags: ['Dashboard'],
    }),
    getProviderProfit: builder.query<ApiResponse<ProviderProfitResponse>, string>({
      query: (providerId) => ({
        url: `/profits/${providerId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, providerId) => [{ type: 'Dashboard', id: `profit-${providerId}` }],
    }),
    resetAllProfits: builder.mutation<ApiResponse<{ message: string }>, void>({
      query: () => ({
        url: '/profits/reset',
        method: 'POST',
      }),
      invalidatesTags: ['Dashboard'],
    }),
    resetProviderProfit: builder.mutation<ApiResponse<{ message: string }>, string>({
      query: (providerId) => ({
        url: `/profits/${providerId}/reset`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error, providerId) => [
        { type: 'Dashboard', id: `profit-${providerId}` },
        'Dashboard',
      ],
    }),
  }),
});

export const {
  useGetProfitsQuery,
  useGetProviderProfitQuery,
  useResetAllProfitsMutation,
  useResetProviderProfitMutation,
} = profitsApi;

